export enum StarConfigurationSetResult {
    Applied = 'Applied',
    Accepted = 'Accepted',
}